/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import Cookie from "js-cookie";
import InvalidSearchResultsView from "./InvalidSearchResultsView";
import NoSearchResultsView from "./NoSearchResultsView";
import ProductListing from "../ProductListing";
import SearchPageWithResultsView from "./SearchPageWithResultsView";
import SimilarSearchResultsView from "./SimilarSearchResultsView";
import Store, { Provider } from "~/common/Store";
import sendSearchABVariationGtmEvent from "./sendSearchABVariationGtmEvent";
import { SearchPageResult as SearchPageProps } from "./SearchPageResult";
import "./SearchRelated.scss";
import "./searchPage.scss";
import "~/less/_critical/category-custom.less";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";
const SearchPage = (detail: SearchPageProps) => {
  const hasMatch = detail.hasSearchValue && detail.bestSearchGuessTerms && detail.bestSearchGuessTerms.numberOfMatches > 0;
  const hasNoMatch = detail.hasSearchValue && detail.bestSearchGuessTerms && detail.bestSearchGuessTerms.numberOfMatches === 0;
  const similarSearchResultsView = detail.similarSearchResults && detail.similarSearchResults.length ? <SimilarSearchResultsView bottomMetaDescription={detail.bottomMetaDescription} similarSearchResults={detail.similarSearchResults} /> : undefined;

  // GTM tracking
  useEffect(() => {
    const abTest = Cookie.get("search") ?? "";
    sendSearchABVariationGtmEvent({
      appliedSearchStrategies: detail.appliedSearchStrategies,
      abTest
    });
  }, []);
  return <FeatureFlagProvider featureFlags={detail.featureFlags} data-sentry-element="FeatureFlagProvider" data-sentry-component="SearchPage" data-sentry-source-file="index.tsx">
      <Provider store={Store} data-sentry-element="Provider" data-sentry-source-file="index.tsx">
        {hasMatch && <ProductListing aboveChromeComponent={<SearchPageWithResultsView detail={detail} />} belowPageComponent={similarSearchResultsView} facetNavigation={detail.facetNavigation} hasBackground={false} hasHeaderData={false} hideFilters={false} hideTopper pageName="SearchPage" pageUrl={detail.originalUrl} pagination={detail.pagination} products={detail.products} promotedProductBrandAd={detail.promotedProductBrandAd} />}

        {hasNoMatch && <InvalidSearchResultsView originalTerm={detail.bestSearchGuessTerms?.originalTerm} />}

        {!detail.hasSearchValue && <NoSearchResultsView />}
      </Provider>
    </FeatureFlagProvider>;
};
export default SearchPage;